export function sanitizeNumberValue(
  value: any,
  nullFriendly = false // if sanitize can return null
): number {
  if (value === null || value === '') {
    return nullFriendly ? null : 0;
  } else if (value == 0) { // this is basically check for empty string https://stackoverflow.com/a/825466
    return 0;
  } else if (typeof value === 'string') {
    try {
      const parsedValue = parseFloat(value);
      return isNaN(parsedValue) ? 0 : parsedValue;
    } catch (e) {
      return 0;
    }
  } else if (!isNaN(value)) {
    return value;
  } else {
    return 0;
  }
}
